import React from "react";
import moment from "moment";
import classes from "./AssignmentMainDashboard.module.css";

import ThemeNoneIcon from "../../../../assets/img/assessmentImages/themeNonePng.png";
import ThemeGreenIcon from "../../../../assets/img/assessmentImages/themeGreenPng.png";
import ThemeRedIcon from "../../../../assets/img/assessmentImages/themeRedPng.png";
import ThemeWhiteIcon from "../../../../assets/img/assessmentImages/themeWhitePng.png";

import { connect } from "react-redux";
import { readAssessment } from "../../../../store/actions/assessment.action";
import { clearQuestion } from "../../../../store/actions/questions.action";
import { Mixpanel } from "../../../../utils/mixpanel";
import { withTranslation } from "react-i18next";

class AssignmentCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  goToAssessment = async () => {
    localStorage.setItem("_assessmentId", this.props.item.id);
    let assessmentId = localStorage.getItem("_assessmentId");
    if (
      this.props.item.AssessmentStatus == "NotAttempted" ||
      this.props.item.AssessmentStatus == "InProgress"
    ) {
      const queryString =
        encodeURIComponent("assessmentId") +
        "=" +
        encodeURIComponent(this.props.item.id);
      Mixpanel.track("Open Assignment");
      this.props.history.push("/start-test?" + queryString);
      return;
    }
    if (this.props.item.AssessmentStatus == "PendingEvaluation") {
      await this.props.clearQuestion();
      await this.props.readAssessment(assessmentId);
      this.props.history.push("/assessments/evaluation-pending");
      return;
    }
    if (this.props.item.AssessmentStatus == "Completed") {
      await this.props.clearQuestion();
      await this.props.readAssessment(assessmentId);
      Mixpanel.track("View Completed Assignment");
      this.props.history.push("/test-submitted");
      return;
    }
  };

  render() {
    const { t } = this.props;
    let imgUrl = "";

    switch (this.props.item.setting.theme) {
      case "ThemeNone":
        imgUrl = ThemeNoneIcon;
        break;
      case "themeNone":
        imgUrl = ThemeNoneIcon;
        break;
      case "ThemeGreen":
        imgUrl = ThemeGreenIcon;
        break;
      case "ThemeRed":
        imgUrl = ThemeRedIcon;
        break;
      case "ThemeWhite":
        imgUrl = ThemeWhiteIcon;
        break;
      default:
        break;
    }

    let assessmentStatus = "";
    switch (this.props.item.AssessmentStatus) {
      case "NotAttempted":
        assessmentStatus = "Not Attempted";
        break;
      case "InProgress":
        assessmentStatus = "In Progress";
        break;
      case "Completed":
        assessmentStatus = "Completed";
        break;
      case "PendingEvaluation":
        assessmentStatus = "Pending Evaluation";
        break;
      default:
        assessmentStatus = "N/A";
        break;
    }

    return (
      <div className={classes.cardwrap} onClick={this.goToAssessment}>
        <div className={classes.assessmenttheme}>
          {" "}
          <img
            src={imgUrl}
            style={{ width: "100%", height: "125px" }}
            alt={this.props.item.setting.theme}
          />
        </div>
        <div className={classes.assesmentname}>
          <div className={classes.assesmentnametitle}>
            {this.props.item.name}
          </div>
          {this.props.item ? (
            <div className={classes.assesmentcreatedon}>
              {t("Published on")}{" "}
              {moment(this.props.item.publishedOn).format(
                "Do MMMM YYYY, h:mm a",
              )}{" "}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className={classes.statustext}>{assessmentStatus}</div>
      </div>
    );
  }
}

export default connect(null, { readAssessment, clearQuestion })(
  withTranslation()(AssignmentCard),
);
